<template>
  <div class="casimir-effect-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F/A = -(π²hc)/(240d⁴) | 真空零点能$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <defs>
             <linearGradient id="metalGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color:#747d8c" />
                <stop offset="50%" style="stop-color:#f1f2f6" />
                <stop offset="100%" style="stop-color:#747d8c" />
             </linearGradient>
          </defs>

          <!-- The Two Plates -->
          <rect :x="200 - d/2 - 10" y="40" width="10" height="160" fill="url(#metalGrad)" stroke="#2f3542" />
          <rect :x="200 + d/2" y="40" width="10" height="160" fill="url(#metalGrad)" stroke="#2f3542" />
          
          <!-- Virtual Particles (Vacuum Fluctuations) -->
          <!-- Outside -->
          <g v-for="n in 20" :key="'out'+n">
             <circle :cx=" Math.random()*80 + (n%2==0 ? 50 : 270)" :cy="Math.random()*160 + 40" r="1.5" fill="#00d2ff" opacity="0.3">
                <animate attributeName="opacity" values="0.3;0;0.3" dur="0.5s" :begin="n*0.1+'s'" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Inside (Fewer modes if d is small) -->
          <g v-for="n in Math.floor(d/4)" :key="'in'+n">
             <circle :cx="200 - d/2 + 5 + Math.random()*(d-10)" :cy="Math.random()*140 + 50" r="1.5" fill="#ffa502" opacity="0.6">
                <animate attributeName="opacity" values="0.6;0;0.6" dur="0.8s" :begin="n*0.2+'s'" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Pressure Arrows -->
          <g v-if="d < 60">
             <line :x1="200 - d/2 - 30" y1="120" :x2="200 - d/2 - 15" y2="120" stroke="#ff4757" stroke-width="2" marker-end="url(#arrow-red)" />
             <line :x1="200 + d/2 + 30" y1="120" :x2="200 + d/2 + 15" y2="120" stroke="#ff4757" stroke-width="2" marker-end="url(#arrow-red)" />
          </g>

          <text x="175" y="220" fill="#888" font-size="8">板间距 d: {{ d }} nm</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>吸引力 F: {{ (1000/Math.pow(d, 4)).toFixed(4) }} μN</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节极板间距</label>
             <el-slider v-model="d" :min="20" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>根据量子场论，所谓的“真空”并非空无一物，而是充满了转瞬即逝的虚粒子涨落（零点能）。当两块电中性的金属板靠得非常近时，板间的空间只能容纳特定频率的波动模式，而板外的波动模式则不受限。这种内外波压的差异产生了一个微弱但可观测的相互吸引力，即**卡西米尔效应**。它是真空具有能量的直接物理证据，也是纳米机电系统（NEMS）设计中必须考虑的关键因素。</p>
        </div>
      </div>
    </div>

    <svg height="0" width="0">
      <defs>
        <marker id="arrow-red" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
           <path d="M0,0 L6,3 L0,6 Z" fill="#ff4757" />
        </marker>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CasimirEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      d: 60
    }
  }
}
</script>

<style scoped lang="scss">
.casimir-effect-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
